import React from 'react';
import PropTypes from 'prop-types';

const OPACITY = {
  1: 1,
  2: 0.8,
  3: 0.6,
  4: 0.4,
  5: 0.2
}

export default function Stars({points}) {
    let count;
    let stars = [];

    if (points >= 5) {
        count = 5;
    } else {
        count = Math.ceil(points);
    }

    let opacityLevel = OPACITY[count]

    for (let i = 0; i < count; i++) {
        stars.push(
            <i key={`star${i}`} className={`star ${points % 1 !== 0 && i === count - 1 ? 'star--half' : ''}`}
              data-char={'\uF0D0'}
              style={{opacity: opacityLevel}}
            />
        )
        opacityLevel += 0.2
    }

    return <React.Fragment>{stars}</React.Fragment>;
}

Stars.propTypes = {
  points: PropTypes.number.isRequired  
};


// WEBPACK FOOTER //
// ./modules/Common/components/TipsWidget/components/Stars.js